import {useState, useEffect} from "react";
import EditChoices from "./EditChoices";
import DriversEdit from "./DriversEdit";
import {Filters, generateUUID} from "../../../../utils/HelpFunctions";
import VehicleEdit from "./VehicleEdit";
import {Animated} from "react-animated-css";
import DownloadDocuments from "./DownloadDocuments";

export const dataEdits = ['Datos del conductor', ' Vehículo/Rutas', 'Descargar documentos',];

function ManagementFormEdit(props) {

    const {
        setTrigger, trigger, DataStore, setEdit, dataEdit, setVisibleGrid, triggerEdit,
        dataDriversArray, setDataEdit,
    } = props


    const [editChoice, setEditChoice] = useState('')
    const [storageID, setStorageID] = useState('')
    const [updateDAtaDrivers, setUpdateDataDrivers] = useState(null)

    useEffect(() => {
        const ID = generateUUID();
        setStorageID(ID)
        setUpdateDataDrivers(dataDriversArray)
        const filterData = Filters(dataDriversArray, 'id', dataEdit.id)
        setDataEdit(filterData[0])
    }, [dataDriversArray])


    return (
        <>
            {editChoice === '' &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <EditChoices setEdit={setEdit} setEditChoice={setEditChoice} setVisibleGrid={setVisibleGrid}
                             editChoice={editChoice} dataEdit={dataEdit}/>
            </Animated>
            }

            {(editChoice === 'Datos del conductor' && dataEdit) &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <DriversEdit setTrigger={setTrigger} trigger={trigger} DataStore={DataStore} storageID={storageID}
                             dataEdit={dataEdit} setVisibleGrid={setVisibleGrid} setEdit={setEdit}
                             dataSource={dataEdit} triggerEdit={triggerEdit} dataDriversArray={updateDAtaDrivers}
                             setEditChoice={setEditChoice} />
            </Animated>}

            {(editChoice === ' Vehículo/Rutas' && dataEdit) &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <VehicleEdit setTrigger={setTrigger} trigger={trigger} DataStore={DataStore} storageID={storageID}
                             setVisibleGrid={setVisibleGrid} setEdit={setEdit} dataSource={dataEdit}
                             triggerEdit={triggerEdit} dataDriversArray={updateDAtaDrivers}
                             setEditChoice={setEditChoice}/>
            </Animated>
            }

            {(editChoice === 'Descargar documentos' && dataEdit) &&
            <DownloadDocuments setEditChoice={setEditChoice} DataStore={DataStore} dataSource={dataEdit}
                               setTrigger={setTrigger} trigger={trigger}/>
            }

        </>
    )
}

export default ManagementFormEdit
